import { render } from "./icons_legend.vue?vue&type=template&id=460c6fd6&scoped=true"
import script from "./icons_legend.vue?vue&type=script&lang=js"
export * from "./icons_legend.vue?vue&type=script&lang=js"

import "./icons_legend.vue?vue&type=style&index=0&id=460c6fd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460c6fd6"]])

export default __exports__